function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9 19 C 8.734375 19 8.480469 18.894531 8.292969 18.707031 L 2.292969 12.707031 C 1.914062 12.3125 1.921875 11.691406 2.304688 11.304688 C 2.691406 10.921875 3.3125 10.914062 3.707031 11.292969 L 9 16.585938 L 20.292969 5.292969 C 20.683594 4.902344 21.316406 4.902344 21.707031 5.292969 C 22.097656 5.683594 22.097656 6.316406 21.707031 6.707031 L 9.707031 18.707031 C 9.519531 18.894531 9.265625 19 9 19 Z M 9 19 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIcon);
export default __webpack_public_path__ + "static/media/TrueIcon.0e566a8d5728b978e7028bd5a7e6f0c0.svg";
export { ForwardRef as ReactComponent };